import { createFileRoute, Link } from "@tanstack/react-router";
import { SiteHeader } from "@/components/SiteHeader";
import { SiteFooter } from "@/components/SiteFooter";

const SITE = "https://mrbquotes.com";

export const Route = createFileRoute("/about")({
  head: () => ({
    meta: [
      { title: "About — Mr. B Quotes" },
      { name: "description", content: "Mr. B Quotes is a home for the world's most thought-provoking words. Our mission is to inspire, inform, and make you think, think, think." },
      { property: "og:title", content: "About Mr. B Quotes" },
      { property: "og:description", content: "Inspire. Inform. Think, think, think." },
      { property: "og:url", content: `${SITE}/about` },
    ],
    links: [{ rel: "canonical", href: `${SITE}/about` }],
  }),
  component: About,
});

function About() {
  return (
    <div className="min-h-screen">
      <SiteHeader active="about" />
      <main id="main" className="mx-auto max-w-3xl px-4 py-16 sm:py-24">
        <article>
        <div className="text-[10px] uppercase tracking-[0.3em] text-muted-foreground">About</div>
        <h1 className="mt-2 font-display text-5xl sm:text-6xl">Inspire. Inform. <span className="text-gold italic">Think, think, think.</span></h1>

        <div className="prose prose-invert mt-10 max-w-none text-muted-foreground leading-relaxed space-y-5 text-lg">
          <p>
            <strong className="text-foreground">Mr. B Quotes</strong> is a small home for big ideas. We gather the words that have moved
            generations — and put them where they belong: in your day, your feed, and your quiet moments.
          </p>
          <p>
            It started on YouTube at <strong className="text-foreground">@ministerjeb</strong>,
            a place to share the lines that make you stop scrolling. From there, it grew: the games, the stories, the glossary, the upcoming
            <em> Mr. B Quotes Music</em>, the upcoming <em>Mr. B Quotes Poems</em>. The format keeps changing. The mission doesn't.
          </p>
          <p className="text-foreground font-display text-2xl border-l-2 border-gold pl-5">
            "We exist to inspire, inform, and make you think, think, think."
          </p>
          <p>
            Every quote we publish is sourced and attributed honestly. We don't invent words and try to put them in the wrong
            mouths. When the historical record is uncertain, we say so — and our <Link to="/glossary" className="text-gold hover:underline">glossary</Link> explains the difference between
            an aphorism, an apocryphal quote, and a flat-out fake.
          </p>
          <p>
            Thank you for being here. Watch a video. Play a game. Read an entry. Send a quote to someone who needs it today.
          </p>
        </div>

        <div className="mt-12 flex flex-wrap gap-3">
          <Link to="/games" className="rounded-full bg-gradient-gold px-6 py-3 text-sm font-semibold text-ink">Play the games</Link>
          <Link to="/glossary" className="rounded-full border border-border px-6 py-3 text-sm hover:border-gold">Open the glossary</Link>
        </div>
        </article>
      </main>
      <SiteFooter />
    </div>
  );
}
